import {
  SET_FEATURE_PROPERTIES_BATCH,
  FETCH_FEATURE_PROPERTIES_REQUEST,
  FETCH_FEATURE_PROPERTIES_SUCCESS,
  FETCH_FEATURE_PROPERTIES_FAILURE
} from './Types';

import _ from 'lodash';
import {
  ICachedProperty,
  IFeatureAction,
  IFeatureReducerState
} from './featuresTypes';

const defaultState = {
  cacheOrder: [],
  cacheProperties: {}
};

const MAX_CACHE = 1000;

export default function reducer(
  state: IFeatureReducerState = defaultState,
  action: IFeatureAction
) {
  const cachedProperty = state.cacheProperties[action.key] || { sections: [] };
  switch (action.type) {
    case SET_FEATURE_PROPERTIES_BATCH:
      return updateFeatures(state, action);
    case FETCH_FEATURE_PROPERTIES_REQUEST:
      return updateFeature(state, action.key, {
        ...cachedProperty,
        isLoading: true
      });
    case FETCH_FEATURE_PROPERTIES_SUCCESS:
      return updateFeature(state, action.key, {
        ...cachedProperty,
        ...action.properties,
        sections: combineSections(cachedProperty.sections, action.sections),
        isLoading: false,
        error: null
      });
    case FETCH_FEATURE_PROPERTIES_FAILURE:
      return updateFeature(state, action.key, {
        ...cachedProperty,
        isLoading: false,
        error: action.error
      });
    default:
      return state;
  }
}

function combineSections(
  existingSections: ICachedProperty[],
  newSections: ICachedProperty[]
) {
  return _.uniq(existingSections.concat(newSections));
}

function updateFeatures(state: IFeatureReducerState, action: IFeatureAction) {
  const features = action.features;
  const order = [...state.cacheOrder];
  const properties = { ...state.cacheProperties };

  for (let i = 0, length = features.length; i < length; ++i) {
    const feature = features[i];
    const key = `${feature.layerSystemName},${feature.featureId}`;
    // Build the feature to create or update
    const cachedFeature = properties[key] || { sections: [] };
    const updateFeature = {
      ...cachedFeature,
      ...feature.properties,
      sections: combineSections(cachedFeature.sections, action.sections)
    };
    // Maintain the order of the cache so used features don't get removed
    const index = order.indexOf(key);
    if (index === -1) {
      if (order.length > MAX_CACHE) {
        delete properties[order.shift()];
      }
      order.push(key);
    } else {
      order.splice(index, 1);
      order.push(key);
    }
    properties[key] = updateFeature;
  }

  return {
    cacheOrder: order,
    cacheProperties: properties
  };
}

function updateFeature(
  state: IFeatureReducerState,
  key: string,
  property: ICachedProperty
) {
  const order = [...state.cacheOrder];
  const properties = { ...state.cacheProperties };
  const index = order.indexOf(key);
  if (index === -1) {
    if (order.length > MAX_CACHE) {
      delete properties[order.shift()];
    }
    order.push(key);
  } else {
    order.splice(index, 1);
    order.push(key);
  }
  properties[key] = property;
  return {
    cacheOrder: order,
    cacheProperties: properties
  };
}
